$(document).ready(function(){
		  $(".playIcon").click(function(){
			  $('audio').trigger('play');
		  });

$('.slider-active_main').slick({
  dots: true,
  arrows: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 23L2 13L12 3" stroke="#E0E0E0" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 23L13 13L3 3" stroke="#E0E0E0" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/></svg></button>',
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  
		});
